export default __webpack_public_path__ + "static/media/kitchen3-before2-768w.4724e62f.webp";